import { usePersonTypeRulesApi } from "../api/PersonTypeRulesApiClient";
import { PersonTypeRulesFrontendService } from "../services/PersonTypeRulesFrontendService";

export const usePersonTypeRulesService = (): PersonTypeRulesFrontendService =>
  new PersonTypeRulesFrontendService(usePersonTypeRulesApi());
